import {Button, Flex} from "@aws-amplify/ui-react"
import CircleIcon from "@mui/icons-material/Circle"
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined"
import {Menu, MenuItem} from "@mui/material"
import * as React from "react"
import {useEffect, useMemo, useState} from "react"
import {MdOutlineNotifications} from "react-icons/md"
import {useNavigate} from "react-router-dom"
import Api from "../../../../api/graphql/Api"
import {SubscribedActivity} from "../../../../models"
import {useMessageService} from "../../../../services/MessageService"
import {useUserAuthenticator} from "../../../../services/UserService"
import Loader from "../../../common/Loader/Loader"
import MuiBadge from "../../../common/MuiBadge"
import NotificationIcons from "./NotificationIcons"
import NotificationMessage from "./NotificationMessage"

const SubscribedActivityApi = new Api("SubscribedActivity")

export default function NotificationsMenu() {
    const {user} = useUserAuthenticator()
    const {
        getMessages,
        getUnreadMessageCount,
        setMessages,
        setUnreadMessages
    } = useMessageService()

    const navigate = useNavigate()

    const [anchorEl, setAnchorEl] = useState(null)
    const [loading, setLoading] = useState<boolean>(true)

    const open = useMemo(() => {
        return Boolean(anchorEl)
    }, [anchorEl])

    const messages = useMemo(() => {
        return getMessages()
    }, [getMessages])

    const unreadMessageCount = useMemo(() => {
        return getUnreadMessageCount()
    }, [getUnreadMessageCount])

    useEffect(() => {
        if (loading) {
            buildNotificationsArray()
        }
    }, [loading])

    //    const subscription = SubscribedActivityApi
    //        .subscribe("Update", {
    //            and: [
    //                {_deleted: {"ne": true}},
    //                {userId: {"eq": user?.username}}
    //            ]
    //        })

    const buildNotificationsArray = () => {
        SubscribedActivityApi
            .runCustomQuery("getNotificationsForUser", {userId: user?.username})
            .then((retrievedNotifications) => {
                setMessages(retrievedNotifications
                    .filter((notification) => {
                        return notification._deleted !== true
                    })
                )
                setUnreadMessages(retrievedNotifications
                    .filter((notification) => {
                        return notification._deleted !== true && notification.read === false
                    })
                )
                setLoading(false)
            })
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const markAllAsRead = (notificationsList) => {
        Promise
            .all(notificationsList
                .filter((notification) => {
                    return notification.read === false
                })
                .map((notification) => {
                        return SubscribedActivityApi
                            .runCustomQuery("markAsRead", {
                                    input: {
                                        id: notification?.id,
                                        _version: notification?._version,
                                        read: true
                                    }
                                }
                            )
                    }
                ))
            .then(() => {
                buildNotificationsArray()
            })
    }

    return <>
        <Button
            variation="link"
            onClick={ handleClick }
            fontWeight="400"
            gap="0.25rem"
            color="white"
            id="notifications-button"
            aria-controls={ open
                ? "notifications-menu"
                : undefined }
            aria-haspopup="true"
            aria-expanded={ open
                ? "true"
                : undefined }
        >
            <MuiBadge badgeContent={ unreadMessageCount}>
                <MdOutlineNotifications
                    color="white"
                    fontSize="2rem"
                />
            </MuiBadge>
            Notifications
        </Button>

        <Menu
            id="notifications-menu"
            anchorEl={ anchorEl }
            open={ open }
            onClose={ () => {
                setAnchorEl(null)
            } }
            MenuListProps={ {
                "aria-labelledby": "notifications-button"
            } }
        >
            <Flex
                direction="row"
                justifyContent="space-between"
                padding="0rem 1rem 0.5rem"
                alignItems="center"
            >
                <div
                    style={ {
                        "fontSize": "1.25rem",
                        "fontWeight": "400"
                    } }
                >
                    Notifications({ unreadMessageCount})
                </div>

                <Button
                    variation="link"
                    size="small"
                    onClick={ () => {
                        markAllAsRead(messages)
                    } }
                >
                    <DraftsOutlinedIcon titleAccess="mark all as read" />
                    Mark All As Read
                </Button>
            </Flex>

            { loading
                ? <Loader />
                : messages
                    .map((notification, index) => {
                        return <MenuItem
                            key={ index }
                            style={ {
                                "minWidth": "22rem",
                                "borderTop": "2px solid #ECECEC",
                                "borderBottom": "2px solid #ECECEC"
                            } }
                        >
                            <Flex direction="row" justifyContent="flex-start" alignItems="center">
                                <Flex
                                    style={ {
                                        "borderRadius": "50%",
                                        "border": "2px solid black",
                                        "padding": "1rem"
                                    } }
                                    alignContent="center"
                                    justifyContent="center"
                                >
                                    <NotificationIcons subscription={ notification?.userSubscription } />
                                </Flex>
                                <NotificationMessage
                                    notification={ notification }
                                    closeMenu={ () => {
                                        setAnchorEl(null)
                                    } }
                                    inMenu={ true }
                                />
                                { notification.read === false
                                    && <CircleIcon
                                        style={ {"color": "var(--amplify-colors-brand-primary-90)"} }
                                        fontSize="small"
                                        titleAccess="unread"
                                    /> }
                            </Flex>
                        </MenuItem>
                    }) }

            <Flex
                direction="row"
                justifyContent="space-between"
                padding="0.5rem 1rem 0rem"
                alignItems="center"
            >
                {/*<SettingsOutlinedIcon titleAccess="settings" />*/ }
                <Button
                    variation="link"
                    size="small"
                    onClick={ () => {
                        setAnchorEl(null)
                        navigate("/notifications")
                    } }
                >
                    View All Notifications
                </Button>
            </Flex>
        </Menu>
    </>
}
